import SkyLinkBg from '../../../../../../public/images/087b2dc3187c09ffe444273797eae2f1348629b4.jpg';

export const useStyles = () => {
  return {
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 99999,
      pointerEvents: 'auto',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
      overscrollBehaviorY: 'contain',
      backgroundImage: `url(${SkyLinkBg})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100%',
      rowGap: 7,
      position: 'relative',
      '@media (max-width: 900px)': {
        rowGap: 4,
        padding: '16px 0 8px',
      },
    },
    backButton: {
      position: 'absolute' as const,
      top: 56,
      left: 56,
      zIndex: 1,
      display: 'inline-flex',
      height: '56px',
      padding: '20px 24px 20px 14px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      flexShrink: 0,
      borderRadius: '99px',
      border: '1px solid #999999',
      textTransform: 'none',
      color: '#999999',
      fontFamily: 'Noto Sans',
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: '140%',
      letterSpacing: 0.2,
      boxShadow: 'none',
      background: 'transparent',
      '@media (max-width: 900px)': {
        fontSize: '16px',
        height: '48px',
        padding: '14px 20px 14px 12px',
        top: 16,
        left: 16,
      },
    },
    title: {
      color: '#2B2B2B',
      textAlign: 'center' as const,
      fontFamily: 'Primary-Bold',
      fontSize: '48px',
      fontWeight: 700,
      letterSpacing: 0.48,
      '@media (max-width: 900px)': {
        fontSize: '28px',
        letterSpacing: 0.28,
        lineHeight: '120%',
        padding: '0 16px',
      },
    },
    subtitle: {
      color: '#999999',
      textAlign: 'center' as const,
      fontFamily: 'Noto Sans',
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: '150%',
      letterSpacing: 0.2,
      '@media (max-width: 900px)': {
        fontSize: '14px',
        lineHeight: '140%',
        padding: '0 20px',
      },
    },
    scrollRow: {
      display: 'flex',
      alignItems: 'center',
      columnGap: 6,
      justifyContent: 'center',
      width: '100%',
      overflowX: 'auto' as const,
      overflowY: 'hidden' as const,
      WebkitOverflowScrolling: 'touch',
      scrollSnapType: 'x proximity',
      flexWrap: 'nowrap' as const,
      touchAction: 'pan-x',
      overscrollBehaviorX: 'contain',
      msOverflowStyle: 'none',
      scrollbarWidth: 'none',
      '@media (max-width: 900px)': {
        alignItems: 'center',
        padding: '8px 16px 4px',
        columnGap: 3,
      },
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  } as const;
};
